import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.locale("en-gb");
dayjs.extend(customParseFormat);

export default dayjs;



// WEBPACK FOOTER //
// ./shared/helpers/dayjs.js